const module = { name: 'discovery/moviesByComingSoon/pagination', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_util as Fandango_util_navigate } from 'require-global';

const { navigate } = Fandango_util_navigate;


import { fd_url_manager as links } from 'require-core';



import { Fandango_queryUtil as Fandango_queryUtil_setParam } from 'require-core';

const { setParam } = Fandango_queryUtil_setParam;


const Selectors = {
    PAGINATION_BTN: '.js-page-btn'
}
function updateUrl(queryString) {
    navigate(links.moviesByComingSoon() + queryString);
}
function onPaginationClick(e) {
    e.preventDefault();
    const page = $(this).data().page;
    if (!page) {
        return;
    }
    updateUrl('?' + setParam('pn', page));
}
function attach() {
    $(Selectors.PAGINATION_BTN).on('click', onPaginationClick);
}
module.exports = {
    attach
};
export default module.exports;